import { TableCell } from "@material-ui/core";
import React from "react";

export default function RedirectToView(props) {
  const { redirectToView, children, style, disabled, className = "" } = props;

  let styleSheet = {
    // color: "#F95A3F",
    cursor: "pointer",
    ...style,
  };
  // }

  //If link is disabled, remove pointer and color
  if (disabled) {
    styleSheet = style;
  }

  return (
    <TableCell className={"ellipsis" + className}>
      <span style={styleSheet} onClick={redirectToView}>
        {children}
      </span>
    </TableCell>
  );
}
